module.exports = __webpack_public_path__ + "static/media/Character1.5308492b.png";